/* eslint-disable prettier/prettier */
import React from 'react';
import { Button } from './Button';

type FeatureCardProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  buttonLabel?: string;
};

export const FeatureCard = ({
  icon,
  title,
  description,
  onClick,
  buttonLabel = 'Open',
}: FeatureCardProps) => {
  return (
    <div className="flex items-center justify-between p-7 py-6 transition bg-white border shadow-md rounded-xl sm:w-[80%]">
      <div className="flex items-center gap-5">
        <div className="p-4 bg-highlight rounded-xl text-primary">{icon}</div>
        <div>
          <h3 className="pb-1 text-xl font-semibold text-primary">{title}</h3>
          <p className="text-md text-secondary">{description}</p>
        </div>
      </div>
      <Button onClick={onClick} className="px-5 py-2 ml-3">
        {buttonLabel}
      </Button>
    </div>
  );
};
